import React, { useState } from "react"
import "semantic-ui-css/semantic.min.css"

const AmountFilter = ({
  onAmountFilterChange = () => {},
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [amount, setAmount] = useState("")
  const [minAmount, setMinAmount] = useState("")
  const [maxAmount, setMaxAmount] = useState("")

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const clearFilter = () => {
    setMinAmount("")
    setMaxAmount("")
    setAmount("")
    onAmountFilterChange({ value: "", minAmount: '', maxAmount: '' })
  }

  const handleMinAmountChange = ({
    target: {
      value: min = "",
    } = {},
  } = {}) => {
    setMinAmount(min)
    onAmountFilterChange({ value: amount, minAmount: min, maxAmount })
  }

  const handleMaxAmountChange = ({
    target: {
      value: max = "",
    } = {},
  } = {}) => {
    setMaxAmount(max)
    onAmountFilterChange({ value: amount, minAmount, maxAmount: max })
  }

  const handleAmountChange = ({
    target: {
      value = "",
    } = {},
  } = {}) => {
    setAmount(value)
    onAmountFilterChange({ value, minAmount, maxAmount })
  }

  return (
    <div>
      <button
        type="button"
        className="facetselector ui button"
        onClick={toggleFilter}
      >
        <i className="euro sign icon" />
        Amount
      </button>

      {isFilterOpen && (
        <div className="filter-popup amount-filter">
          <h4>Amount</h4>
          <input
            type="number"
            placeholder="Enter an amount"
            className="amount-input"
            onChange={handleAmountChange}
            value={amount}
          />
          <h4>Or An Amount Range</h4>
          <input
            type="number"
            placeholder="Enter a min amount"
            className="amount-input"
            onChange={handleMinAmountChange}
            value={minAmount}
          />
          <input
            type="number"
            placeholder="Enter a max amount"
            className="amount-input"
            onChange={handleMaxAmountChange}
            value={maxAmount}
          />
          <button
            type="button"
            className="ui button"
            onClick={() => {
              clearFilter()
            }}
            style={{ marginTop: "10px" }}
          >
            Clear
          </button>
          <button
            type="button"
            className="ui button"
            onClick={() => {
              setIsFilterOpen(false)
            }}
            style={{ marginTop: "10px" }}
          >
            Close
          </button>
        </div>
      )}
      {(minAmount || maxAmount || amount) && (
        <div className="active-filter selected-active-filter">
          <span>
            {amount && `Amount: ${amount} `}
            {minAmount && `Min: ${minAmount} `}
            {maxAmount && `Max: ${maxAmount}`}
          </span>
          <button
            type="button"
            className="remove-filter"
            onClick={clearFilter}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  )
}

export default AmountFilter
